<template>

    <v-ons-list>

        <!-- Allergy warning -->
        <allergy-warning-list-item
            v-show="allow_allergy_warning && basket.outlet.show_allergy_warnings"
            v-bind:phone="basket.outlet.phone_no"
            v-bind:message="basket.outlet.allergy_message"
            v-bind:link="basket.outlet.allergy_link"/>

        <!-- Products -->
        <v-ons-list-item class="list-item-basket"
                         v-for="item in items"
                         v-bind:key="item.uuid">
            <div class="left">
                <img class="item-image" v-show="productImage(item.product.product_id)" v-bind:src="productImage(item.product.product_id)">
                <div class="item-image-empty" v-show="productImage(item.product.product_id) == null"
                    v-bind:style="{ backgroundColor: product(item.product.product_id).display_colour ? `#${product(item.product.product_id).display_colour}` : '' }">
                    {{ item.product.product_name.length > 0 ? item.product.product_name.substring(0, 1).toUpperCase() : '' }}
                </div>
            </div>
            <div class="center">
                <span class="list-item__title">
                    {{ item.product.product_name }}
                </span>
                <span class="list-item__subtitle">
                    {{ item.subtitle }}
                    <div v-show="editable == false">
                        {{ item.quantity }} {{ filters.pluralise(item.quantity, 'item') }} x
                        {{ filters.money(item.price / item.quantity, false, outlet.currency_symbol) }}
                    </div>
                </span>
                <div class="product-details-row" v-show="editable">
                    <span v-if="item.quantity == 1" class="quantity-trash" v-on:click="internalChangeProductQuantity(item.uuid, 'subtract')">
                        <svg class="icon-trash"></svg>
                    </span>
                    <span v-if="item.quantity > 1" class="quantity-minus" v-on:click="internalChangeProductQuantity(item.uuid, 'subtract')"> - </span>
                    <span class="quantity-text">{{ item.quantity }}</span>
                    <span class="quantity-plus" v-on:click="internalChangeProductQuantity(item.uuid, 'add')">+</span>
                </div>
            </div>
            <div class="right">
                <span class="item-price-text">
                    {{ filters.money(item.price, false, outlet.currency_symbol) }}
                </span>
            </div>
        </v-ons-list-item>

        <!-- Vouchers -->
        <v-ons-list-item v-for="item in basket.vouchers"
                         class="list-item-basket"
                         v-bind:key="item.voucher.product_id">
            <div class="left">&nbsp;</div>
            <div class="center">
                {{ item.voucher.product_name }}
                <span class="list-item__subtitle" v-show="editable == false">
                    {{ item.quantity }} {{ filters.pluralise(item.quantity, 'item') }} x
                    {{ filters.money(item.price / item.quantity, false, outlet.currency_symbol) }}
                </span>
                <div class="row product-details-row" v-show="editable">
                    <span v-if="item.quantity == 1" v-on:click="internalChangeVoucherQuantity(item.amount, 'subtract')">
                        <svg class="icon-trash"></svg>
                    </span>
                    <span v-if="item.quantity > 1" class="quantity-minus" v-on:click="internalChangeVoucherQuantity(item.amount, 'subtract')">-</span>
                    <span class="quantity-text">{{ item.quantity }}</span>
                    <span class="quantity-plus" v-on:click="internalChangeVoucherQuantity(item.amount, 'add')">+</span>
                </div>
            </div>
            <div class="item-price-text right">
                 {{ filters.money(item.price, false, outlet.currency_symbol) }}
            </div>
        </v-ons-list-item>

        <!-- Promotions -->
        <v-ons-list-item v-for="(promotion, index) in promotion_items"
                         class="list-item-basket"
                         v-bind:key="promotion.id">
            <div class="left">&nbsp;</div>
            <div class="center">
                <span v-if="promotion.quantity > 1">({{ promotion.quantity }}x)&nbsp;</span>
                {{ promotion.name }}
            </div>
            <div class="right">
                <span class="item-price-text">
                    {{ filters.money((-1 * promotion.discount) / 100, false, outlet.currency_symbol) }}
                </span>
            </div>
        </v-ons-list-item>

        <!-- Service / Delivery charge -->
        <v-ons-list-item v-if="service_charge" class="list-item-basket list-item-margin">
            <div class="left">&nbsp;</div>
            <div class="center">
                {{ service_charge.title }}
                <span class="list-item__subtitle">
                    <template v-if="service_charge.message">
                        {{ service_charge.message }}
                    </template>
                    <template v-else>
                        <template v-if="service_charge.is_percentage">
                            {{ parseFloat(service_charge.percentage) }}% of item total,
                        </template>
                        Applied to {{ service_charge.type.toLowerCase() }} orders
                        <template v-if="parseFloat(service_charge.cutoff)">
                            below {{ filters.money(service_charge.cutoff, true, outlet.currency_symbol) }}
                        </template>
                    </template>
                </span>
            </div>
            <div class="right">
                {{ filters.money(service_charge.amount, false, outlet.currency_symbol) }}
            </div>
        </v-ons-list-item>

        <!-- Total / Subtotal-->
        <v-ons-list-item class="list-item-basket list-item-total" v-show="has_items">
            <div class="left">&nbsp;</div>
            <div class="center">
                <span class="item-price-text">
                    {{ total_label }}
                </span>
            </div>
            <div class="right">
                <span class="item-price-text">
                    {{ filters.money(total_value, true, outlet.currency_symbol) }}
                </span>
            </div>
        </v-ons-list-item>


    </v-ons-list>


</template>

<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex'
    import AllergyWarningListItem from '../fragments/allergy_warning_list_item'

    export default {
        name: "product-basket-list-item",

        props: [
            'basket',
            'editable',
            'service_charge',
            'allow_allergy_warning',
            'promotions_after_discount',
            'total_label',
            'total_value',
        ],

        components: {
           'allergy-warning-list-item': AllergyWarningListItem,
        },

        methods: {

            ...mapMutations([
                'changeProductQuantity',
                'changeVoucherQuantity',
            ]),

            internalChangeProductQuantity(uuid, action){
                this.changeProductQuantity({
                    uuid,
                    action,
                    outlet: this.basket.outlet,
                    callback: () => this.$emit('basketChanged'),
                })
            },

            internalChangeVoucherQuantity(amount, action){
                this.changeVoucherQuantity({
                    amount,
                    action,
                    outlet: this.basket.outlet,
                    callback: () => this.$emit('basketChanged'),
                })
            },
        },

        computed: {
            ...mapGetters([
                'outlet',
                'order',
                'basketInfo',
                'productImage',
                'product',
            ]),

            items(){
                return this.basket.items
            },

            has_items() {
                return this.items.length > 0
            },

            promotion_items: function(){
                const promotions_key = this.promotions_after_discount && this.basket.coupon ? 'promotions_after_coupon' : 'promotions_before_coupon'
                return this.basket[promotions_key].valid_promotions
            },
        },
    }
</script>

<style scoped>
    .item-image-empty, .item-image {
        width: 54px;
        height: 54px;
    }

    .list-item-basket .left {
        margin-right: 10px;
    }

    .product-details-row {
        order: 3;
        display: flex;
        text-align: center;
        margin-top: 5px;
    }

    .product-details-row span {
        margin-right: 10px;
    }

    .quantity-trash {
        cursor: pointer;
    }

    .product-details-row .quantity-minus {
        background-color: #e1e1e1;
        color: white;
        font-weight: bold;
        border-radius: 100%;
        width: 30px;
        height: 30px;
        line-height: 28px;
        cursor: pointer;
    }

    .product-details-row .quantity-text {
        background-color: #e1e1e1;
        color: #181D1E;
        border-radius: 100%;
        width: 30px;
        height: 30px;
        line-height: 30px;
    }

    .product-details-row .quantity-plus {
        margin-right: 10px;
        background-color: #62D6B6;
        color: white;
        font-weight: bold;
        border-radius: 100%;
        width: 30px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/fragments/basket.vue